import { getCookie } from '@/helpers/getCookie'

export const locale = getCookie('DittoMusic[lang]') || 'en'
